/**
 * Mirrors the negative-lookahead portion of Highnote's stricter Line 1 regex
 * (FAQ Q6, taking effect 2026-06-08). Returns true when the value contains
 * content that belongs in the second address line — secondary unit designators,
 * `#digit` formats, or commas.
 *
 * PO Box detection is intentionally separate (handled by the existing PO Box
 * regex), since PO Boxes are blocked from identity addresses entirely and
 * carry a different user-facing message.
 *
 * The structural part of HN's regex (digits + street name + suffix) is NOT
 * mirrored here — it produces false positives on legitimate addresses like
 * "One World Trade Center" that don't begin with a digit.
 */

const SECONDARY_UNIT_DESIGNATORS = [
  'APT',
  'UNIT',
  'STE',
  'SUITE',
  'FL',
  'FLOOR',
  'BLDG',
  'BUILDING',
  'DEPT',
  'DEPARTMENT',
  'RM',
  'ROOM',
  'PENTHOUSE',
  'PH',
  'BASEMENT',
  'BSMT',
  'FRONT',
  'FRNT',
  'HANGAR',
  'HNGR',
  'LOBBY',
  'LBBY',
  'LOWER',
  'LOWR',
  'REAR',
  'SLIP',
  'SPACE',
  'SPC',
  'TRAILER',
  'TRLR',
  'UPPER',
  'UPPR',
];

const SECONDARY_UNIT_REGEX = new RegExp(`\\b(?:${SECONDARY_UNIT_DESIGNATORS.join('|')})\\b`, 'i');
const HASH_NUMBER_REGEX = /#\s*\d/;
const COMMA_REGEX = /,/;

export function containsSecondaryDetails(line1: string | null | undefined): boolean {
  if (!line1) return false;
  return SECONDARY_UNIT_REGEX.test(line1) || HASH_NUMBER_REGEX.test(line1) || COMMA_REGEX.test(line1);
}
